import type { ComponentPropsWithoutRef, JSX, ReactElement, ReactNode } from 'react';

import { cx } from './internal/cx.js';

export interface FormControlLabelProps extends ComponentPropsWithoutRef<'label'> {
  /** Checkbox or radio control. */
  control: ReactElement;
  label: ReactNode;
  /** When true, label appears after the control (default). */
  labelPlacement?: 'end' | 'start';
}

/** Accessible label paired with a checkbox or radio control. */
export function FormControlLabel({
  control,
  label,
  labelPlacement = 'end',
  className,
  ...props
}: FormControlLabelProps): JSX.Element {
  return (
    <label
      className={cx(
        'nrx-form-control-label',
        labelPlacement === 'start' && 'nrx-form-control-label--start',
        className,
      )}
      {...props}
    >
      {control}
      <span className="nrx-form-control-label__text">{label}</span>
    </label>
  );
}
